import Tooltip from 'components/tooltips/Tooltip'

import styles from './bracketInfoToolTip.module.scss'

const BracketInfoToolTip = () => {
  return (
    <Tooltip
      style={{ padding: 'none' }}
      content={
        <div className={styles.tooltip}>
          <BracketOne />
          <BracketTwo />
          <BracketThree />
          <BracketFour />
          <BracketFive />
        </div>
      }
    />
  )
}

export default BracketInfoToolTip

type BracketBlurbProps = {
  className?: string
}

const BracketOne = ({ className = '' }: BracketBlurbProps) => (
  <div className={className}>
    <div className={styles.bold}>Bracket 1: - Exhibition</div>
    <p>Your ultra-casual commander deck</p>
    <ul>
      <li>No mass land denial</li>
      <li>No extra turns</li>
      <li>No 2-card infinite combos</li>
      <li>No Game Changers</li>
      <li>Few tutors</li>
    </ul>
  </div>
)

const BracketTwo = ({ className = '' }: BracketBlurbProps) => (
  <div className={className}>
    <div className={styles.bold}>Bracket 2: Core:</div>
    <p>
      Decks to be unoptimized and straightforward, with some cards chosen to maximize creativity and/or entertainment
    </p>
    <ul>
      <li>No mass land denial</li>
      <li>No extra turns</li>
      <li>No 2-card infinite combos</li>
      <li>No Game Changers</li>
      {/* <li>Few tutors</li> */}
    </ul>
  </div>
)

const BracketThree = ({ className = '' }: BracketBlurbProps) => (
  <div className={className}>
    <div className={styles.bold}>Bracket 3: Upgraded:</div>
    <p>Beyond the strength of the average precon deck</p>
    <ul>
      <li>No mass land denial</li>
      <li>No chaining extra turns</li>
      <li>
        Up to <b>three</b> Game Changers
      </li>
    </ul>
  </div>
)

const BracketFour = ({ className = '' }: BracketBlurbProps) => (
  <div className={className}>
    <div className={styles.bold}>Bracket 4: Optimized:</div>
    <p>High power Commander.</p>
    <ul>
      <li>No restrictions (other than the Commander banlist)</li>
    </ul>
  </div>
)

const BracketFive = ({ className = '' }: BracketBlurbProps) => (
  <div className={className}>
    <div className={styles.bold}>Bracket 5: cEDH Experience</div>
    <p>High power commander with a very competetive and metagame focused mightset.</p>
    <ul>
      <li>No restrictions (other than the Commander banlist)</li>
    </ul>
  </div>
)

export const BracketBlurbs = {
  BracketOne,
  BracketTwo,
  BracketThree,
  BracketFour,
  BracketFive,
}
